import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const PorcentajeDescuentoPromocionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='% DESCUENTO' htmlFor='number-porcentajeDescuentoPromocion' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='porcentajeDescuentoPromocion'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='number-porcentajeDescuentoPromocion'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PorcentajeDescuentoPromocionFormGroup)
